export default __webpack_public_path__ + "static/media/h-lr-b.d8e58e96.png";